import React from 'react'
import {components, GroupBase, MultiValueProps} from 'react-select'
import {MAX_VISIBLE_TAGS, TSelectOption, TTagsCollapseSelectProps} from '../_types'

export const CollapsedMultiValue: React.FC<
    MultiValueProps<TSelectOption, boolean, GroupBase<TSelectOption>>
> = (props) => {
    const {isTagsExpanded, onToggleTagsExpanded, maxVisibleTags} =
        props.selectProps as unknown as TTagsCollapseSelectProps
    const resolvedMaxVisibleTags = maxVisibleTags ?? MAX_VISIBLE_TAGS
    const allValues = props.getValue() as TSelectOption[]
    const overflowCount = allValues.length - resolvedMaxVisibleTags
    const isLast = props.index === allValues.length - 1

    const handleBadgeClick = (e: React.MouseEvent) => {
        e.preventDefault()
        e.stopPropagation()
        onToggleTagsExpanded()
    }

    if (isTagsExpanded || overflowCount <= 0) {
        return (
            <>
                <components.MultiValue {...props} />
                {isLast && overflowCount > 0 && (
                    <div
                        className='componentSelect__overflow-badge componentSelect__overflow-badge--collapse'
                        onMouseDown={handleBadgeClick}
                    >
                        ↑
                    </div>
                )}
            </>
        )
    }

    if (props.index < resolvedMaxVisibleTags) {
        return <components.MultiValue {...props} />
    }

    if (props.index === resolvedMaxVisibleTags) {
        return (
            <div className='componentSelect__overflow-badge' onMouseDown={handleBadgeClick}>
                +{overflowCount}
            </div>
        )
    }

    return null
}